// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__ATHLc","fileBtn":"File_fileBtn__1Grwx","closeBtn":"File_closeBtn__1XZWs","fileSelected":"File_fileSelected__1Suc-","disabled":"File_disabled__23rPT"};